export const SNOW_PLOW_ANALYTICS_CONTEXT_KEY = "SnowPlowAnalyticsContext";
